// Mock data para Pack Cinematográfico Premium

export const productData = {
  id: 'pack_cinematografico_premium',
  name: 'Pack Cinematográfico Premium',
  tagline: 'Tenha acesso a CENAS CINEMATOGRÁFICAS PREMIUM e transforme qualquer vídeo em filme de alto orçamento',
  description: 'O Pack Cinematográfico Premium é um pack com + de 100 cenas cinematográficas exclusivas, prontas pra arrastar e soltar na edição e deixar qualquer projeto com cara de produção de cinema.',
  originalPrice: 167.00,
  currentPrice: 37.00,
  scenesCount: 60,
  features: [
    {
      title: 'Cenas de abertura',
      description: 'Cenas perfeitas para abrir vídeos com impacto, prender atenção nos primeiros segundos e fugir totalmente do visual amador.',
      icon: 'play-circle'
    },
    {
      title: 'Cenas de transição',
      description: 'Clipes pensados para ligar uma cena na outra com fluidez, criando ritmo e narrativa cinematográfica de verdade.',
      icon: 'film'
    },
    {
      title: 'Cenas de B-Roll Cinematográfico',
      description: 'Detalhes, texturas, movimentos suaves e enquadramentos pensados pra dar profundidade e storytelling aos seus vídeos.',
      icon: 'camera'
    },
    {
      title: 'Cenas de clímax e impacto',
      description: 'Cenas mais intensas, com movimentos fortes ou composições marcantes, ideais pra momentos chave, ofertas, chamadas e grandes viradas no vídeo.',
      icon: 'zap'
    },
    {
      title: 'Cenas multiuso para qualquer nicho',
      description: 'Takes versáteis que funcionam para infoprodutos, negócios locais, marcas pessoais, lifestyle, viagens, moda, tech, gastronomia e muito mais.',
      icon: 'sparkles'
    }
  ],
  withoutPack: [
    'Perder horas tentando deixar vídeos simples com cara de cinema, sem ter cenas de apoio de qualidade.',
    'Continuar usando os mesmos takes genéricos de banco gratuito que todo mundo usa.',
    'Deixar de cobrar mais caro porque seu vídeo não tem a estética profissional que o cliente vê nos grandes produtores.',
    'Ter dificuldade pra manter consistência visual entre os projetos.'
  ],
  withPack: [
    'Otimizar em até 10x o processo de criar vídeos mais bonitos, só arrastando e soltando as cenas na timeline.',
    'Ter um acervo próprio de + de 100 cenas cinematográficas exclusivas, que poucos editores têm.',
    'Entregar vídeos com estética de cinema e poder aumentar seu ticket com segurança.',
    'Ter um arsenal pronto de cenas pra usar em diversos clientes e nichos.'
  ],
  benefits: [
    '+ de 100 cenas cinematográficas em alta qualidade',
    'Atualizações futuras incluídas',
    'Acesso imediato via download',
    'Uso comercial liberado para seus projetos'
  ],
  faqs: [
    {
      question: 'Consigo usar em qualquer programa de edição?',
      answer: 'Sim. As cenas são entregues em formato de vídeo padrão, que funcionam nos principais programas de edição (Premiere, DaVinci, Final Cut, CapCut, etc.).'
    },
    {
      question: 'Consigo usar pelo celular?',
      answer: 'Sim! Basta baixar os arquivos e importar no seu app de edição favorito no celular.'
    },
    {
      question: 'Por quanto tempo tenho acesso?',
      answer: 'O acesso é vitalício. Comprou uma vez, as cenas são suas pra sempre.'
    },
    {
      question: 'Como recebo o pack?',
      answer: 'Assim que o pagamento é aprovado, você recebe um e-mail automaticamente com o link de acesso e download do Pack Cinematográfico Premium.'
    },
    {
      question: 'Posso usar em projetos para clientes?',
      answer: 'Sim, as cenas são liberadas para uso comercial em projetos para seus clientes (não é permitido revender o pack em si).'
    }
  ],
  about: {
    name: 'Diorgy',
    imageUrl: 'https://midia.packcinematografico.com/Gemini_Generated_Image_mn37zamn37zamn37.png',
    description: 'Trabalho com edição há mais de 4 anos, casado, com dois filhos, cristão e empreendedor no mercado digital. Especialista em reels dinâmicos de alta retenção para criadores de conteúdo e infoprodutores.'
  }
};

export const testimonials = [
  {
    image: 'https://midia.packcinematografico.com/WhatsApp%20Image%202026-01-09%20at%2012.43.36.jpeg',
    alt: 'Depoimento 1'
  },
  {
    image: 'https://midia.packcinematografico.com/WhatsApp%20Image%202026-01-09%20at%2012.43.36%20(1).jpeg',
    alt: 'Depoimento 2'
  },
  {
    image: 'https://midia.packcinematografico.com/WhatsApp%20Image%202026-01-06%20at%2010.30.25.jpeg',
    alt: 'Depoimento 3'
  },
  {
    image: 'https://midia.packcinematografico.com/WhatsApp%20Image%202026-01-06%20at%2010.29.44.jpeg',
    alt: 'Depoimento 4'
  },
  {
    image: 'https://midia.packcinematografico.com/WhatsApp%20Image%202026-01-06%20at%2010.29.58.jpeg',
    alt: 'Depoimento 5'
  }, // <--- Faltava essa vírgula aqui
  {
    image: 'https://midia.packcinematografico.com/WhatsApp%20Image%202026-01-06%20at%2010.29.13.jpeg',
    alt: 'Depoimento 6'
  },
  {
    image: 'https://midia.packcinematografico.com/WhatsApp%20Image%202026-01-06%20at%2010.29.29.jpeg',
    alt: 'Depoimento 7'
  },
  {
    image: 'https://midia.packcinematografico.com/WhatsApp%20Image%202026-01-09%20at%2012.42.52.jpeg',
    alt: 'Depoimento 8'
  },
  {
    image: 'https://midia.packcinematografico.com/WhatsApp%20Image%202026-01-06%20at%2010.31.27.jpeg',
    alt: 'Depoimento 9'
  },
];
export const showcaseScenes = [
  { id: 1, category: 'Cena Cinematográfica', videoUrl: 'https://customer-assets.emergentagent.com/job_pro-footage/artifacts/zoahlsft_Sequence%2004_8.mp4' },
  { id: 2, category: 'Cena Cinematográfica', videoUrl: 'https://customer-assets.emergentagent.com/job_pro-footage/artifacts/p8l5yqo2_Sequence%2004_10.mp4' },
  { id: 3, category: 'Cena Cinematográfica', videoUrl: 'https://customer-assets.emergentagent.com/job_pro-footage/artifacts/14j05v9j_Sequence%2003.mp4' },
  { id: 4, category: 'Cena Cinematográfica', videoUrl: 'https://customer-assets.emergentagent.com/job_pro-footage/artifacts/5u6tsopi_Sequence%2003_2.mp4' },
  { id: 5, category: 'Cena Cinematográfica', videoUrl: 'https://customer-assets.emergentagent.com/job_pro-footage/artifacts/egq8som9_Sequence%2002_6.mp4' },
  { id: 6, category: 'Cena Cinematográfica', videoUrl: 'https://customer-assets.emergentagent.com/job_pro-footage/artifacts/q8zxb637_Sequence%2005_2.mp4' },
  { id: 7, category: 'Cena Cinematográfica', videoUrl: 'https://customer-assets.emergentagent.com/job_pro-footage/artifacts/94ba1yk3_Sequence%2005_4.mp4' },
  { id: 8, category: 'Cena Cinematográfica', videoUrl: 'https://customer-assets.emergentagent.com/job_pro-footage/artifacts/55lbkdt9_IMG_6952.mp4' },
 
];

export const resultVideos = [
  {
    id: 1,
    title: 'Viral',
    videoUrl: 'https://midia.packcinematografico.com/Um%20mundo%20de%20pessoas%20cansadas.V%C3%ADdeo%20novo%20sobre%20%E2%80%9CA%20Sociedade%20do%20Cansa%C3%A7o%E2%80%9D%20dispon%C3%ADvel%20atrav%C3%A9s%20do%20lin.mp4',
    posterUrl: '',
    tag: "Edição Viral"
  },
  {
    id: 3,
    title: 'Mindset Shift',
    videoUrl: 'https://midia.packcinematografico.com/Seasonal%20alignment%20is%20the%20solution%20to%20most%20of%20your%20problems.Modern%20life%20is%20tricking%20your%20biology.mp4',
    posterUrl: 'https://midia.packcinematografico.com/Captura%20de%20tela%202026-03-20%20090510.png',
    tag: "Mindset"
  },
  {
    id: 2,
    title: 'Impact',
    videoUrl: 'https://midia.packcinematografico.com/My%20notebook-%2073%20business%20ideas%20since%202019My%20launches-%200A%20teenager%20built%20and%20sold%20an%20AI%20app%20for%20%24.mp4',
    posterUrl: 'https://midia.packcinematografico.com/Captura%20de%20tela%202026-03-20%20090439.png',
    tag: "Vlog Travel"
  },
  {
    id: 4,
    title: 'Business Growth',
    videoUrl: 'https://midia.packcinematografico.com/Learn%20to%20trust%20your%20gut%2C%20it%20already%20knows..mp4',
    posterUrl: 'https://midia.packcinematografico.com/Captura%20de%20tela%202026-03-20%20090429.png',
    tag: "Business"
  },
  {
    id: 5,
    title: 'Lifestyle Cinematic',
    videoUrl: 'https://midia.packcinematografico.com/Anyone%20can%20start%20hot%20in%20sales%E2%80%A6.mp4',
    posterUrl: 'https://midia.packcinematografico.com/Captura%20de%20tela%202026-03-20%20090420.png',
    tag: "Lifestyle"
  },
  {
    id: 6,
    title: 'Visual Impact',
    videoUrl: 'https://midia.packcinematografico.com/According%20to%20neuroscience%2C%20the%20most%20successful%20artists%2C%20athletes%20and%20entrepreneurs%20are%20actually%20.mp4',
    posterUrl: 'https://midia.packcinematografico.com/Captura%20de%20tela%202026-03-20%20090408.png',
    tag: "Cinematic"
  }
];

export const bonuses = [
  {
    title: 'Pack de Efeito Sonoro Cinematográfico',
    description: 'Mais de 50 efeitos sonoros profissionais para dar aquele toque final épico nas suas edições: impactos, transições, ambientes e muito mais.',
    image: "https://res.cloudinary.com/dxphh6tjh/image/upload/v1771002151/sdfgdsfgdsfgdsgdg_qqsbat.png"
  },
  {
    title: 'Pack de LUTs Cinematográficas',
    description: 'Transforme suas cenas com LUTs profissionais que dão aquele look de cinema em 1 clique. Compatível com todos os principais editores.',
    image: "https://res.cloudinary.com/dxphh6tjh/image/upload/v1771002151/fdgdsfgsdfg_ajqlrg.png"
  },
  {
    title: 'Biblioteca de Hooks & Estruturas',
    description: 'Roube minhas estruturas prontas pra criar vídeos com começo, meio e fim envolventes – é só colar no seu nicho.',
    image: 'https://res.cloudinary.com/dxphh6tjh/image/upload/v1771002473/asdgfdhfghjghhk_tyu73b.png'
  },
  {
    title: "Pack de Overlays",
    description: "Eleve o nível visual das suas edições com elementos prontos para aplicar em qualquer projeto. Cada asset foi criado para gerar impacto imediato na tela — sem precisar criar do zero.",
    image: "https://res.cloudinary.com/dxphh6tjh/image/upload/v1771002219/Adobe_Express_-_filedfd_1_op19ct.png"
  }
];
